"use strict";

var _ = require('lodash');

var filtersHandler = {};

filtersHandler.setSimilarPatientsFilter = function (dataParallelPlot, similarPatientsFilter, activePatient, validationWarnings, environment) {

  var columnPatientsArray = [];
  _.each(similarPatientsFilter.columnPatients, function (patients, cat) {
    columnPatientsArray.push(patients);
  });

  _.each(similarPatientsFilter.brushedPatients, function (patients, cat) {
    columnPatientsArray.push(patients);
  });

  columnPatientsArray = _.sortBy(columnPatientsArray, function (o) {
    return o.length;
  });

  //clear array
  similarPatientsFilter.patients = [];

  _.each(columnPatientsArray, function (filter, index) {
    if (index === 0) {
      similarPatientsFilter.patients = filter;
    } else {
      var newList = [];
      _.each(similarPatientsFilter.patients, function (patient) {

        var equal = _.find(filter, function (p) {
          return patient.patientID === p.patientID;
        });
        if (equal) {
          newList.push(equal);
        }
      });
      similarPatientsFilter.patients = newList;
    }
  });

  similarPatientsFilter.patientsIdMap = {};
  similarPatientsFilter.nrPatients = 0;

  _.each(similarPatientsFilter.patients, function (p) {
    similarPatientsFilter.patientsIdMap[p.patientID] = p.patientID;
    similarPatientsFilter.nrPatients++;
  });

  similarPatientsFilter.filtersActive = false;
  _.each(similarPatientsFilter.columnPatients, function (column) {
    similarPatientsFilter.filtersActive = true;
  });
  _.each(similarPatientsFilter.brushedPatients, function (column) {
    similarPatientsFilter.filtersActive = true;
  });

  //check validations data warning
  validationWarnings.patientIsOutFilterSelection = false;
  validationWarnings.sampleSizeTooSmall = false;
  var sampleSizeTooSmall = false;

  if (similarPatientsFilter.filtersActive) {
    filtersHandler.checkFilterOutlierDetection(dataParallelPlot, similarPatientsFilter, activePatient, validationWarnings);

    if (similarPatientsFilter.nrPatients < similarPatientsFilter.minSampleSize) validationWarnings.sampleSizeTooSmall = true;
    if (similarPatientsFilter.nrPatients < similarPatientsFilter.minSampleSize) sampleSizeTooSmall = true;
  };

  // for ISPM, sampleSizeTooSmall is set in updateHandler
  if (environment !== "ISPM") {
    validationWarnings.sampleSizeTooSmall = sampleSizeTooSmall;
  }

  var filterProps = { similarPatientsFilter: similarPatientsFilter, validationWarnings: validationWarnings };
  return filterProps;
};

filtersHandler.checkFilterOutlierDetection = function (dataParallelPlot, similarPatientsFilter, activePatient, validationWarnings) {

  validationWarnings.patientIsOutFilterSelection = null;
  if (!activePatient) return;
  if (similarPatientsFilter.patientsIdMap[activePatient.features.patientID]) return;

  validationWarnings.patientIsOutFilterSelection = { warning: true, columns: {} };

  //check brush selections
  _.each(similarPatientsFilter.brushedSelection, function (brush, columnID) {

    var sourceColumn = _.find(dataParallelPlot, function (c) {
      return c.column.id === columnID;
    });

    var filterRange = [];
    filterRange[0] = sourceColumn.column.scaleY.invert(brush[0]);
    filterRange[1] = sourceColumn.column.scaleY.invert(brush[1]);

    filterRange = _.sortBy(filterRange, function (d) {
      return d;
    });

    if (activePatient.features[columnID] < filterRange[0] || activePatient.features[columnID] > filterRange[1]) {
      validationWarnings.patientIsOutFilterSelection.columns[columnID] = columnID;
    }
  });

  //check category selections
  _.each(similarPatientsFilter.columnSelection, function (filterColumn, columnID) {
    var inFilterCategory = false;
    _.each(filterColumn, function (c) {
      if (c.category === activePatient.features[c.column]) inFilterCategory = true;
    });
    if (!inFilterCategory) validationWarnings.patientIsOutFilterSelection.columns[columnID] = columnID;
  });

  //console.log(D3PP.validationWarnings);
};

module.exports = filtersHandler;